module.exports = __webpack_public_path__ + "static/media/black-ash.772b4ad2.jpg";